
const TabTableTinhCongTruc = (props: any) => {
    const { data } = props;

    const totalWeekdays = data.reduce((sum: number, item: any) => sum + item.soNgayTrucThuong, 0);
    const totalWeekends = data.reduce((sum: number, item: any) => sum + item.soNgayTrucCuoiTuan, 0);
    const totalHolidays = data.reduce((sum: number, item: any) => sum + item.soNgayTrucLeTet, 0);

    return (
        <div className="overflow-x-auto">
            <table className="w-100 table-tinh-cong-truc">
                <thead>
                    <tr className="tr">
                        <th rowSpan={2} className="th">STT</th>
                        <th rowSpan={2} className="th">Họ và tên</th>
                        <th colSpan={2} className="th">Ngày Thường</th>
                        <th colSpan={2} className="th">T7, Chủ nhật</th>
                        <th colSpan={2} className="th">Ngày Lễ</th>
                        <th rowSpan={2} className="th">Tổng tiền</th>
                    </tr>
                    <tr className="tr">
                        <th className="th">Số</th>
                        <th className="th">Số tiền</th>
                        <th className="th">Số</th>
                        <th className="th">Số tiền</th>
                        <th className="th">Số</th>
                        <th className="th">Số tiền</th>
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ?
                        <>
                            {data.map((item: any, index: number) => (
                                <tr key={`nhanvien-${index}`}>
                                    <td className="td text-center">{index + 1}</td>
                                    <td className="td text-left">{item.employeeText}</td>
                                    <td className="td text-center">{item.soNgayTrucThuong}</td>
                                    <td className="td text-center"></td>
                                    <td className="td text-center">{item.soNgayTrucCuoiTuan}</td>
                                    <td className="td text-center"></td>
                                    <td className="td text-center">{item.soNgayTrucLeTet}</td>
                                    <td className="td text-center"></td>
                                    <td className="td text-center"></td>
                                </tr>
                            ))}
                            <tr>
                                <td colSpan={2} className="td font-bold text-left">CỘNG</td>
                                <td className="td text-center">{totalWeekdays}</td>
                                <td className="td"></td>
                                <td className="td text-center">{totalWeekends}</td>
                                <td className="td"></td>
                                <td className="td text-center">{totalHolidays}</td>
                                <td className="td"></td>
                                <td className="td"></td>
                            </tr>
                            <tr>
                                <td colSpan={9} className="td font-bold text-left">Bằng chữ: ..................................................................................................</td>
                            </tr>
                        </>
                        :
                        <tr>
                            <td colSpan={9} className="td font-bold text-center">Không có bản ghi nào</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
};

export default TabTableTinhCongTruc;